import OffersErrorDisplay from './OffersErrorDisplay';

export default OffersErrorDisplay;
